module.exports = __webpack_public_path__ + "img/popup-recharge-passive.92793a15.png";